import { render, staticRenderFns } from "./ednMail.vue?vue&type=template&id=77de74c7&"
import script from "./ednMail.vue?vue&type=script&lang=js&"
export * from "./ednMail.vue?vue&type=script&lang=js&"
import style0 from "./ednMail.vue?vue&type=style&index=0&id=77de74c7&prod&lang=scss&"


/* normalize component */
import normalizer from "!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports